<div class="ea-dialog">

  <!-- Header -->
  <div class="ea-header">
    <div class="ea-title-wrap">
      <div class="ea-title-icon">
        <mat-icon>add_task</mat-icon>
      </div>
      <div class="ea-title-text">
        <h2 class="ea-title">Add event</h2>
        @if (startDate?.value != null) {
          <div class="ea-subtitle">{{startDate.value | date:'EEEE, MMMM d, y'}}</div>
        } @else {
          <div class="ea-subtitle">Plan a task for your team</div>
        }
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="ea-close" [disabled]="saving" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form id="updateEvent" class="ea-form" (ngSubmit)="saveEvent()">

    <!-- Hero: what needs doing -->
    <div class="ea-hero">
      <div class="ea-hero-input">
        <input class="ea-desc" [class.invalid]="descriptionHasError" type="text" name="description"
          placeholder="What needs to be done?" [(ngModel)]="event.description" autocomplete="off">
        @if (descriptionHasError) {
          <div class="ea-desc-error">Event description cannot be empty</div>
        }
      </div>
      <button type="button" class="ea-flag" [class.on]="event.highPriority"
        (click)="event.highPriority = !event.highPriority" aria-label="Toggle high priority">
        <mat-icon>flag</mat-icon>
        High priority
      </button>
    </div>

    <!-- Body -->
    <div class="ea-body">

      <!-- Left: where & when -->
      <div class="ea-col-main">

        <div class="ea-field">
          <label class="ea-label">Assign to</label>
          @if (needToPickHarvest) {
            <div class="ea-seg">
              <button type="button" [class.on]="!assignToGroup" (click)="assignToGroup = false">Harvest</button>
              <button type="button" [class.on]="assignToGroup" (click)="assignToGroup = true">Task group</button>
            </div>
          }
          @if (!assignToGroup) {
            <div class="ea-picker">
              <app-harvest-select
                [disabled]="!needToPickHarvest"
                [includeCompleted]="!needToPickHarvest"
                [(harvestId)]="harvestId"
                [(harvest)]="harvest">
              </app-harvest-select>
            </div>
          }
          @if (assignToGroup) {
            <div class="ea-picker">
              <app-group-select
                [disabled]="!needToPickGroup"
                [(groupId)]="groupId"
                [(group)]="group">
              </app-group-select>
            </div>
          }
        </div>

        @if (harvest != null && !assignToGroup) {
          <div class="ea-field">
            <label class="ea-label">Phase</label>
            <div class="ea-picker">
              <app-phase-select [harvestId]="harvest.uid" [date]="startDate.value" [(phase)]="event.phase"></app-phase-select>
            </div>
          </div>
        }

        @if (needToPickDate) {
          <div class="ea-field">
            <label class="ea-label">Date</label>
            <div class="ea-picker">
              <mat-form-field>
                <input matInput [matDatepicker]="startDatePicker" placeholder="Pick a date" [formControl]="startDate"
                  disabled="true">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        }

        <div class="ea-field">
          <label class="ea-label">Time</label>
          <div class="ea-time-row">
            <div class="ea-seg">
              <button type="button" [class.on]="event.anyTime" (click)="event.anyTime = true">Anytime</button>
              <button type="button" [class.on]="!event.anyTime" (click)="event.anyTime = false">At a time</button>
            </div>
            @if (!event.anyTime) {
              <input class="ea-time" type="time" name="startTime" [(ngModel)]="eventTime">
            }
          </div>
        </div>

        <div class="ea-field ea-field-last">
          <label class="ea-label">Repeat</label>
          <button type="button" class="ea-repeat" [class.on]="repeatEvent" (click)="repeatBtn()">
            <mat-icon>{{repeatEvent ? 'autorenew' : 'repeat'}}</mat-icon>
            <span class="ea-repeat-text">{{repeatSummary}}</span>
            <span class="ea-repeat-cta">{{repeatEvent ? 'Edit' : 'Set up'}}</span>
          </button>
        </div>
      </div>

      <!-- Right: who & details -->
      <aside class="ea-col-side">

        <div class="ea-side-section">
          <div class="ea-side-head">
            <span class="ea-side-title">Assignees</span>
            <button type="button" class="ea-mini-btn" (click)="selectUsers()">
              <mat-icon>person_add</mat-icon>
              Assign
            </button>
          </div>
          @if (assigneeSummary) {
            <div class="ea-assignee-summary">
              <mat-icon>group</mat-icon>
              {{assigneeSummary}}
            </div>
          } @else {
            <div class="ea-side-empty">No one assigned yet</div>
          }
        </div>

        <div class="ea-side-section">
          <div class="ea-side-head">
            <span class="ea-side-title">Subtasks</span>
            @if (editEventAbility) {
              <button type="button" class="ea-mini-btn" (click)="editSubtasks($event)" [disabled]="event.completed">
                <mat-icon>checklist</mat-icon>
                Edit
              </button>
            }
          </div>
          @if (!subtasksEmpty) {
            <ul class="ea-subtasks">
              @for (subtask of subtasks; track subtask) {
                <li class="ea-subtask">
                  <div class="ea-subtask-row">
                    <mat-checkbox class="subtask_checks" [(ngModel)]="subtask.subtask.completed" [ngModelOptions]="{standalone: true}">
                      {{subtask.subtask.title}}
                    </mat-checkbox>
                    @if (subtask.subtask.description?.length > 0) {
                      <button type="button" class="ea-subtask-toggle" (click)="subtaskDescToggle($event, subtask)"
                        [attr.aria-label]="subtask.displayDescription ? 'Hide description' : 'Show description'">
                        <mat-icon>{{subtask.displayDescription ? 'expand_less' : 'expand_more'}}</mat-icon>
                      </button>
                    }
                  </div>
                  @if (subtask.displayDescription) {
                    <p class="ea-subtask-desc">{{subtask.subtask.description}}</p>
                  }
                </li>
              }
            </ul>
          } @else {
            <div class="ea-side-empty">No subtasks yet</div>
          }
        </div>

        <div class="ea-side-section ea-side-section-note">
          <div class="ea-side-head">
            <span class="ea-side-title">Note</span>
          </div>
          <textarea class="ea-note" name="notes" [(ngModel)]="notes" placeholder="Leave a note for the team..."></textarea>
        </div>
      </aside>
    </div>
  </form>

  <!-- Footer -->
  <div class="ea-footer">
    <span class="ea-footer-when">
      @if (startDate?.value != null) {
        <mat-icon>event</mat-icon>
        {{startDate.value | date:'EEE, MMM d'}}
        <span class="ea-sep">·</span>
        {{event.anyTime ? 'Anytime' : (eventTime || 'No time set')}}
        @if (repeatEvent) {
          <span class="ea-sep">·</span>
          Repeats
        }
      }
    </span>
    <div class="ea-footer-actions">
      <button mat-button mat-dialog-close class="ea-btn-ghost" [disabled]="saving">Cancel</button>
      <button type="submit" form="updateEvent" class="ea-btn-primary" [disabled]="saving">
        @if (saving) {
          <mat-spinner diameter=20 strokeWidth=3></mat-spinner>
        } @else {
          <span>Add event</span>
          <mat-icon>check</mat-icon>
        }
      </button>
    </div>
  </div>
</div>
